export const CapitalizeFirstLetter = (word: string) => {
    const words = word.split('-').flatMap(word => word.split(' '));
  
    const capitalizedWords = words.map(word => {
      return word.charAt(0).toUpperCase() + word.slice(1);
    });
  
    const capitalizedSentence = capitalizedWords.join(' ');
  
    return capitalizedSentence;
};
